import { Action, createReducer, on } from '@ngrx/store';
import { IGenericError, ErrorResponse } from 'src/app/core/models/generic-models';
import { fromGovIdProofActions } from '../actions';
import { IGovIdProof } from '../models/govId.model';

export const govIdProofFeatureKey = 'govIdProof';

export interface GovIdProofState {
  govIdProofRequest: string;
  govIdProofResponse: IGovIdProof;
  govIdProofFailure: IGenericError<ErrorResponse>;
}

export const initialState: GovIdProofState = {
  govIdProofRequest: undefined,
  govIdProofResponse: undefined,
  govIdProofFailure: undefined
};

export const reducer = createReducer(
  initialState,

  on(fromGovIdProofActions.loadProofGovIds, (state, action) => ({
    ...state,
    govIdProofRequest: action.request
  })),
  on(fromGovIdProofActions.loadProofGovIdsSuccess, (state, action) => ({
    ...state,
    govIdProofResponse: action.response
  })),
  on(fromGovIdProofActions.loadProofGovIdsFailure, (state, action) => ({
    ...state,
    govIdProofFailure: action.error
  }))
);

export const getGovIdProofRequest = (state: GovIdProofState) => state.govIdProofRequest;
export const getGovIdProofResponse = (state: GovIdProofState) => {
  return state.govIdProofResponse;
};
export const getGovIdProofFailure = (state: GovIdProofState) => state.govIdProofFailure;
